// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__3qooq","vLegacy":"SelectSecondary_vLegacy__1r75r","error":"SelectSecondary_error__OOuWL","disabled":"SelectSecondary_disabled__1G5eP"};